import mixpanel from 'mixpanel-browser'
import { combineAnalytics } from 'aria-viewer/core/middleware/analyticsMiddleware'
import { MIXPANEL_TOKEN } from 'aria-viewer/tour/constants/'

import paymentAnalytics from 'aria-viewer/payments/analytics/desktopAnalytics'
import modalAnalytics from 'aria-viewer/modal/analytics/desktopAnalytics'
import ctaPromptAnalytics from 'aria-viewer/ctaPrompt/analytics/desktopAnalytics'
import supplementalMediaViewAnalytics from 'aria-viewer/players/supplementalmedia/analytics/desktopAnalytics'
import tourAnalytics from 'aria-viewer/tour/analytics/desktopAnalytics'
import analyticAnalytics from 'aria-viewer/analytics/analytics/desktopAnalytics'
import drawerAnalytics from 'aria-viewer/drawer/analytics'
import guideAnalytics from 'aria-viewer/guide/analytics'
import { interactiveElementsAnalytics } from 'aria-viewer/interactive-element'
import panoPlayerAnalytics from 'aria-viewer/players/panoplayer/analytics'

const customMapper = {
    analytics: mixpanel,

    token: MIXPANEL_TOKEN,
    // This mapper will capture the events fired from actions, if the event type matches, sends properties to mixpanel
    mapper: combineAnalytics(
        paymentAnalytics,
        modalAnalytics,
        ctaPromptAnalytics,
        supplementalMediaViewAnalytics,
        tourAnalytics,
        analyticAnalytics,
        drawerAnalytics,
        guideAnalytics,
        interactiveElementsAnalytics,
        panoPlayerAnalytics
    ),
}

export default customMapper
